import {subscribe} from './queue.js';

// Allows reading from a stream of messages as they come in
// You read once which reads everything thats happened since you last
// called read.
export const reader = (type) => {
    let queued = [];

    subscribe(
        type, 
        x => queued = [x, ... queued]);

    return () => {
        let ret = [... queued];
        queued = [];
        return ret;
    };
};
